import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import RoutesDefined from "./Routes/Routes";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <RoutesDefined />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
